module.exports = __webpack_public_path__ + "static/media/Norbi Update Low Carb kafa.ac32a369.jpg";